import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

export const playerName = style({
  paddingBottom: vars.space.m,
  textAlign: "center",
  color: vars.colors.onSurface,
});
